<template>
  <base-material-card color="secondary" icon="mdi-cube-outline" :title="$t('buy_product')">
    <v-container>
      <v-row v-if="RBAC_BUY_FOR_OTHER_USER">
        <v-autocomplete v-model="masterId" :items="selectUsers" item-text="text" item-value="value" @change="resetForm"
          dense :label="$t('select_user')"></v-autocomplete>
      </v-row>
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step :step="1" :editable="stepper >= 1" :complete="stepper > 1">{{ $t("confirm_profile_data")
          }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :step="2" :editable="stepper >= 2 && typeof idProduct !== 'undefined'"
            :complete="stepper > 2 && typeof idProduct !== 'undefined'">{{ $t("configure_product") }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :step="3" :editable="stepper >= 3" :complete="stepper > 3">{{ $t("exec_payment")
          }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content :step="1">
            <user-edit-profile :paramsMasterId="masterId" paramsMode="EDIT" paramsType="plain" :paramsIfConfirm="true"
              @isUpdated="confirmData"></user-edit-profile>
          </v-stepper-content>
          <v-stepper-content :step="2">
            <product-configuration :idProduct="idProduct" @configured="configureProduct" :upgrade="true">
            </product-configuration>
          </v-stepper-content>
          <v-stepper-content :step="3">
            <select-mod-pag :idProduct="idProduct" :riepilogo="riepilogo" @selected="confirmOrder"
              :usePoint="true"></select-mod-pag>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </base-material-card>
</template>

<script>
import Swal from "sweetalert2";
import userEditProfile from "@/widget/userEditProfile.vue";
import productConfiguration from "@/widget/productConfiguration.vue";
import selectModPag from "@/widget/selectModPag.vue";

export default {
  name: "buy-product",
  components: {
    userEditProfile,
    selectModPag,
    productConfiguration,
  },
  props: {
    idProduct: 0,
  },
  data() {
    return {
      masterId: null,
      stepper: 1,
      selectUsers: [],
      productConfig: null,
      pagId: null,
      dataPag: null,
      riepilogo: {
        headers: [
          { text: this.$t("item"), value: "item" },
          { text: this.$t("option"), value: "selectedOptions" },
          { text: this.$t("price"), value: "prezzo" },
        ],
        items: [],
        totale: 0,
      },
      RBAC_BUY_FOR_OTHER_USER: false,
    };
  },
  created() {
    this.RBAC_BUY_FOR_OTHER_USER = this.checkUserRole(
      "prodotti",
      "BUY_FOR_OTHER_USER"
    );
    if (this.RBAC_BUY_FOR_OTHER_USER) {
      let url = "/auth/portal/listUsers";
      let filter = { filter: { type: "tutti" } };
      let _ = this;
      _.selectUsers = [];
      this.chiamataAxios("POST", url, { body: filter }).then((response) => {
        _.selectUsers = response.data.map(function (item) {
          return {
            value: item.masterId,
            text:
              item.surname +
              " " +
              item.name +
              "   -   " +
              item.resCity +
              " (" +
              item.eta +
              " anni)",
          };
        });
      });
      if (this.$route.params.masterId)
        this.masterId = parseInt(this.$route.params.masterId);
      else this.masterId = myData.masterId;
    } else {
      this.masterId = myData.masterId;
    }
  },
  methods: {
    confirmData() {
      this.stepper = 2;
      this.$globalHandler.scroll.toTop = true;
    },
    resetForm() {
      this.stepper = 1;
      this.idProduct = null;
      this.productConfig = null;
    },
    confirmOrder(pagamento) {
      this.dataPag = pagamento.dataPag;
      this.pagId = pagamento.pagId;

      let data = {
        idProduct: this.idProduct,
        productConfig: this.productConfig,
        pagId: this.pagId,
        dataPag: this.dataPag,
        usePoint: pagamento.selectedPoint,
      };
      let _ = this;
      let url =
        "/auth/prodotti/buyProduct/" + this.masterId + "/" + this.idProduct;
      this.chiamataAxios("POST", url, { body: data, dialogLoader: true }).then(
        (response) => {
          if (response.data.payUrl) {
            Swal.fire({
              title: _.$t("redirect_to_external_site"),
              html: _.$t("for_complete_the_payment_operation"),
            }).then((result) => {
              window.open(response.data.payUrl);
            });
          } else {
            Swal.fire({
              type: response.msg.esito ? "success" : "error",
              title: response.msg.esito
                ? _.$t("operation_successfully_completed")
                : _.$t("there_was_an_error"),
              html: response.msg.msgTxt,
            });
          }
          _.$router.push("/portal/");
        }
      );
    },

    configureProduct(configured) {
      let _ = this;
      _.productConfig = configured;
      // Prepara riepilogo
      _.riepilogo.totale = 0;
      _.riepilogo.items = [];
      if (this.idProduct && _.productConfig) {
        _.productConfig.selectedConfiguration.forEach((config) => {
          _.riepilogo.totale += _.productConfig.prezzo;
          let options = [];
          let metadata = [];
          for (var key in config.options) {
            // check if the property/key is defined in the object itself, not in parent
            if (config.options.hasOwnProperty(key)) {
              options.push(key + ": " + config.options[key]);
            }
          }
          for (var key in config.metadata) {
            // check if the property/key is defined in the object itself, not in parent
            if (config.metadata.hasOwnProperty(key)) {
              metadata.push(config.metadata[key]);
            }
          }

          _.riepilogo.items.push({
            item: _.productConfig.title,
            selectedOptions:
              _.productConfig.type === "PORTAL_REQUEST"
                ? config.metadata.ragSoc
                : options.join(", ") + " " + metadata.join(" "),
            prezzo: _.productConfig.prezzo,
          });
        });
      } else {
        _.productConfig = null;
      }
      _.stepper = 3;
    },
  },
};
</script>